import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, Popover2} from '@api'
import {Menu, MenuItem} from '@blueprintjs/core'
import {ContentTitleBarItemField, useChangeLogFlexLayoutTabStore, useVipLocalStore, VipLocalStore} from '@modules'
import {useChangeLogTitleBarStore} from '@modules/changelog/toolbar/ChangeLogTitleBar'
import {icons, StoresInstance} from '@stores'
import {PrimaryIconButton, SearchField2} from 'centric-ui-components'
import * as css from './FilterDropdownButton.css'

/// region Store

export class FilterDropdownButtonStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'>) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = []

    return () => {
      _toDispose.forEach(d => d())
    }
  }
}

export const FilterDropdownButtonStoreContext = React.createContext<FilterDropdownButtonStore>(null)
export const useFilterDropdownButtonStore = () => React.useContext(FilterDropdownButtonStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const FilterDropdownButton = observer<MyProps>(function FilterDropdownButton({className, ...props}) {
  const obsProps = useAsObservableSource({...props}),
    store = useVipLocalStore((stores) => new FilterDropdownButtonStore(stores, obsProps)),
    {} = store

  useEffect(() => store.registerEffects(), [])

  return (
    <FilterDropdownButtonStoreContext.Provider value={store}>
      <div className={classNames(css.root, className)}>


      </div>
    </FilterDropdownButtonStoreContext.Provider>)
})

/// endregion

export const ChangeLogToggleFiltersDropdownIcon = observer(function ChangeLogToggleFiltersDropdownIcon() {
  const {filterFields, shouldApplyFilters, toggleApplyFilters, onToggleFilterField, filteredFields, catalog: {labelForField}} = useChangeLogFlexLayoutTabStore(),
    {searchText, onSearch, values} = useChangeLogTitleBarStore()

  return (<Popover2
    interactionKind='hover'
    position={'bottom'}
    content={<div className={css.root}>
      <Menu className={css.menu}>
        <div className={css.container}><SearchField2 data-type={'search-field'} className={css.search} active autoFocus onSearch={onSearch} value={searchText}/></div>
        {values.map(f =>
          <ContentTitleBarItemField key={f.field}
                                    field={f}
                                    workspace={f.workspace}
                                    renderTo={'applied'}
                                    onSelectMenuItem={onToggleFilterField(f.field)}
                                    isSelected={filteredFields.has(f.field)}/>)}
      </Menu>
    </div>}
  >
    <PrimaryIconButton
      icon={icons.filter}
      tooltip='Filter Log'
      tooltipPosition='right'
      tooltipStyle='blueprint'
    />
  </Popover2>)
})


// WEBPACK FOOTER //
// ./src/modules/changelog/toolbar/FilterDropdownButton.tsx